import MyTabs from '../../components/MyTabs';
import Section1 from './Section1/Section1';

const GeneralInsights = () => {

    const tabs = [
        { id: "section1", title: "Insight Info", Component: Section1  },
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default GeneralInsights;